export default __webpack_public_path__ + "static/media/human.2496dc18.svg";